module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<button class="button button-secondary">\n    <img src="/static/icons/names_magic.png" />\n    Names\n</button>\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./names/templates/button.html
// module id = 357
// module chunks = 0